import './index.scss';
import { useSelector } from 'react-redux';
import { DialogContent, DialogContentText, DialogTitle, IconButton } from '@material-ui/core';
import { UserInfo } from '@components/SharedComponents/UserInfo';
import CloseIcon from '@material-ui/icons/Close';
import { EmailIcon } from '@images/icons';
import { translate } from '@utils';
import { MgState, UserEntityInterface } from '@types';
import { FEEDBACK_FORM_SUBJECT } from '@constants/index';

interface Props {
  users: UserEntityInterface[];
  onClose: () => void;
}

export const FeedbackModal = ({ onClose, users }: Props) => {
  const emails = useSelector<MgState, string[]>(({ feedback }) => feedback?.supportData?.emails);

  return (
    <div data-testid="feedback-modal" className="feedback-modal">
      <DialogContent className="close-icon-container">
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogContent>
      <DialogTitle className="feedback-modal-title" data-testid="feedback-modal-title">
        {translate('contact_us')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="feedback-modal-subtitle">
          {translate('leave_feedback')}
        </DialogContentText>
        <DialogContentText className="feedback-modal-sent">
          <IconButton
            className="btn-close"
            aria-label="close"
            onClick={onClose}
            href={`mailto:${emails.join(';')}?subject=${FEEDBACK_FORM_SUBJECT}`}
            target="_blank"
          >
            <EmailIcon width={32} height={32} />
          </IconButton>
        </DialogContentText>
        <DialogContentText className="feedback-modal-subtitle">
          {translate('reach_out_us')}
        </DialogContentText>
      </DialogContent>
      <DialogContent>
        {users.map(({ rank, skype, email, fullNameEng, id }) => (
          <UserInfo
            name={fullNameEng}
            position={rank.name}
            skype={skype}
            email={email}
            key={`${id}`}
            userId={id}
          />
        ))}
      </DialogContent>
    </div>
  );
};
